import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledTab, StyledTabs } from "./AdminSettingPanel";
import IconList from "./PointAreaSettingIconList";
import PointAreaList from "./PointAreaSettingList";
import PointAreaExternalFileList from "./PointAreaSettingExternalList";

const useStyles = makeStyles({
	settingTopBox: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingTab: {
	},
	settingBody: {
		flexGrow: 1,
		marginTop: '-1px',
		border: '1px solid #a7a7a7',
		overflow: 'hidden',
	},
});

export function PointAreaSettingBox() {
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const classes = useStyles();
	const {t} = useTranslation();

	return (
		<div className={clsx(classes.settingTopBox)} style={{ height: '100%' }}>
			<Box className={classes.settingTab}>
				<StyledTabs
					value={value}
					onChange={handleChange}
				>
					<StyledTab label={t('Point and Area List')} />
					<StyledTab label={t('Icon List')} />
					<StyledTab label={t('External File List')} />
				</StyledTabs>
			</Box>
			<Box className={classes.settingBody}>
				{value === 0 && <PointAreaList />}
				{value === 1 && <IconList />}
				{value === 2 && <PointAreaExternalFileList />}
			</Box>
		</div>
	);
}
